import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

const tailwindBreakpoints = useBreakpoints(breakpointsTailwind, {
  // 在服务端渲染时没有真实的浏览器窗口，所以暂时指定屏幕宽度为 768px
  ssrWidth: 768,
})

/** 根据tailwind断点，动态判断客户端屏幕宽度 */
export const useClientWidth = () => {
  return {
    isSmWidth: tailwindBreakpoints.smaller('md'),
    isMdWidth: tailwindBreakpoints.smaller('lg'),
    isLgWidth: tailwindBreakpoints.greaterOrEqual('lg'),
  }
}
